import {
    GET_WEEKLY_STAR_SETTINGS,
    UPDATE_WEEKLY_STAR_GIFTS,
    UPDATE_WEEKLY_STAR_REWARDS,
    OPEN_WEEKLY_STAR_REWARD_DIALOG,
    CLOSE_WEEKLY_STAR_REWARD_DIALOG,
    OPEN_WEEKLY_STAR_GIFT_DIALOG,
    CLOSE_WEEKLY_STAR_GIFT_DIALOG,
} from "./types";

const initialState = {
    settings: null,
    dialog: false,
    dialogData: null,
    giftDialog: false,
    giftDialogData: null,
};

const weeklyStarReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WEEKLY_STAR_SETTINGS:
            return {
                ...state,
                settings: action.payload,
            };
        case UPDATE_WEEKLY_STAR_GIFTS:
            return {
                ...state,
                settings: action.payload,
            };
        case UPDATE_WEEKLY_STAR_REWARDS:
            return {
                ...state,
                settings: action.payload,
            };
        case OPEN_WEEKLY_STAR_REWARD_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
            };
        case CLOSE_WEEKLY_STAR_REWARD_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
            };
        case OPEN_WEEKLY_STAR_GIFT_DIALOG:
            return {
                ...state,
                giftDialog: true,
                giftDialogData: action.payload || null,
            };
        case CLOSE_WEEKLY_STAR_GIFT_DIALOG:
            return {
                ...state,
                giftDialog: false,
                giftDialogData: null,
            };
        default:
            return state;
    }
};

export default weeklyStarReducer;
